export const FunderPayrollInvoiceModeOptions = Object.freeze([
  { label: 'Default', value: 'default' },
  { label: 'Include KM into Hours/Units', value: 'include_km_into_hours' },
  { label: 'Include KM into Rate', value: 'include_km_into_rate' }
])
export const FunderPayrollInvoiceModeOption = Object.freeze(Object.fromEntries(FunderPayrollInvoiceModeOptions.map((option) => [option.value, option])))